module.exports = __webpack_public_path__ + "img/tool_zoom_active.33f913aa.png";